<template>
  <el-collapse
    v-model="collapseModel"
    :accordion="true"
  >
    <el-collapse-item
      title="Detalle de entrega"
      name="deliveries"
    >
      <el-row style="align-items: center">
        <el-button
          type="primary"
          size="default"
          @click="addDelivery"
          >+1</el-button
        >
        <el-button
          :icon="IconDelete"
          type="danger"
          size="default"
          :disabled="deliveries && !deliveries.length"
          @click="removeDelivery"
        />
        <input-deliveries-item
          v-for="(delivery, index) in deliveries"
          :key="index"
          :delivery="delivery"
          :precision="precision"
          @update-delivery="emit('update-delivery', { delivery: $event, index })"
        />
      </el-row>
    </el-collapse-item>
  </el-collapse>
</template>

<script setup>
import { ref } from 'vue';
import IconDelete from '~icons/mdi/delete';
import InputDeliveriesItem from '@/shared/components/input_deliveries_item.vue';

const collapseModel = ref([]);

defineProps({
  deliveries: { type: Array, required: true, default: () => [] },
  precision: { type: Number, default: 0 },
});

const emit = defineEmits(['add-delivery', 'remove-delivery', 'update-delivery']);

const addDelivery = () => {
  emit('add-delivery');
};

const removeDelivery = () => {
  emit('remove-delivery');
};
</script>

<style scoped></style>
